import {createContext, useState} from "react";


export const OrdersContext = createContext({
    selectedChatRefId:null,
    setSelectedChatRefId: ()=>null,
    activeTab:null,
    setActiveTab:()=>null,
    ordersCount :null,
    setOrdersCount:()=>null,
    activeFilter:null,
    setActiveFilter:()=>null,
    refresh:null,
    setRefresh:()=>null,
});

export const OrdersContextProvider = ({children}) =>{
    const [selectedChatRefId,setSelectedChatRefId] = useState(null);
    const [activeTab,setActiveTab] = useState(null);
    const [ordersCount,setOrdersCount] = useState({
        pendingForQuotation:0,
        underReview:0,
        activeOrders:0,
        shippedOrders:0,
        deliveredOrders:0,
        unapprovedQuotes:0,
        closedOrders:0,
        billedOrders:0,
    });
    const [activeFilter,setActiveFilter] = useState(null);
    const [refresh,setRefresh] = useState(0);

    const value = {
                    selectedChatRefId,
                    setSelectedChatRefId,
                    activeTab,
                    setActiveTab,
                    ordersCount,
                    setOrdersCount,
                    activeFilter,
                    setActiveFilter,
                    refresh,
                    setRefresh,
                }
    return <OrdersContext.Provider value={value}>{children}</OrdersContext.Provider>
}